var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewYoutubeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#595D5C",
  d: "M20.605 7.69a2.24 2.24 0 0 0-1.58-1.612c-1.413-.395-7.007-.395-7.007-.395s-5.628 0-7.043.395a2.24 2.24 0 0 0-1.58 1.612C3 9.073 3 12.034 3 12.034s0 2.929.395 4.344c.197.79.823 1.382 1.58 1.58 1.414.36 7.042.36 7.042.36s5.594 0 7.009-.361a2.2 2.2 0 0 0 1.58-1.58C21 14.963 21 12.035 21 12.035s0-2.963-.395-4.345M10.174 14.7V9.369l4.672 2.665-4.672 2.665"
})));
export default SvgNewYoutubeIcon;